import { FC, FormEvent } from 'react';
import BackNextButtons from 'components/BackNextButtons';
import PersonalInfo from 'components/forms/PersonalInfo/NonSSN';
import type { OCRFormutil } from 'modules/Open/type';
import values from 'stores/values';
import { reportEventList } from 'utils/gtag';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const BaseInfo2: FC<ProgressFormProps> = ({ onSubmit, $formutil }) => {
    const {
        $params: { id_type: formIdType }
    } = $formutil;
    const { legal_residence_country, tax_residence_country } = values.getParams<OCRFormutil>();

    const handleSubmit = (ev: FormEvent) => {
        onSubmit('../address', ev);

        reportEventList('personalInfo');
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <h3 className="open-title mt-0">{__('PERSONAL INFORMATION')}</h3>
            <PersonalInfo
                type="baseinfo2"
                hideHomeAddress
                idNumberProps={{
                    maskIdNo: null,
                    idType: formIdType
                }}
                countryProps={{
                    isSSN: false,
                    disabled: true
                }}
                legalResidenceCountry={legal_residence_country}
                taxResidenceCountry={tax_residence_country}
            />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    step: 1,
    id: 'baseinfo2',
    basePath: 'open',
    ensure: ['account', 'baseinfo'],
    showProgressBar: true,
    eventParams: {
        exposureEventParams: {
            model: '开户-基础信息2',
            name: '基础信息2-页面曝光'
        },
        submitEventParams: {
            model: '开户-基础信息2',
            name: '基础信息2-点击下一步'
        }
    }
})(BaseInfo2);
